import MultiTreeSelector from 'scoreboard/components/multi-tree-selector'
import i18n from 'scoreboard/components/i18n'
import DatasetTreeGardener from '../dataset-tree-gardener'
import _ from 'lodash'
import KeyDisplay from 'scoreboard/datasets/key-display'
import $ from 'jquery'
import rollupFilterDropdown from 'scoreboard/datasets/filters/rollup-filter-dropdown'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'

var DatasetsRollupFilterStep2 = MultiTreeSelector.extend({

 	className: MultiTreeSelector.prototype.className + ' datasets-rollup-filter-step2',

	/** @type {Dataset} */
	model: null,

	/**
	 * Second step for adding a rollup filter, which is either an "is any"
	 * or "is not any" filter
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model
	 *
	 * @param {Object} options.filter the filter we're working with
	 *
	 * @param {Boolean} options.new indicates if this is a new filter or not
	 *
	 * @param {String} [options.title=this.options.wizard.step2Title()] the
	 * title for the dialog
	 *
	 * @param {FilterWizard} [options.wizard]
	 *
	 * @param {Boolean} [options.showPermissionFilters=false] whether we are
	 * working with permission filters
	 */
	initialize: function(options) {
		MultiTreeSelector.prototype.initialize.apply(this, arguments)
		this.on('done', function(selections, treeItems) {
			this.options.wizard?.finish({ treeItems })
		}.bind(this))
		this.formView.options.allowCleanSubmission = true
		this.formView.test = this.test.bind(this)
		// whether rollup permissions should be displayed instead of the usual
		// cascade checkboxes (#20557)
		this.rollupPermissions = this.options.filter.operator === 'is-any'
		if (this.rollupPermissions) {
			// #23990 disable rollup permissions properly
			this._ids = _.cloneDeep(_.get(this.options, 'filter.rollupIsAnyFilters', {}))
		}
		this.markedFields = []
	},

	createGardener: function() {
		let underlyingField = this.model.getUnderlyingField(this.options.filter.fieldId)
		const gardener = new DatasetTreeGardener({
			id: underlyingField.treeId,
			showKeys: underlyingField.showKeys
		})
		gardener.on('search', () => this.setActiveTreeActionsButton())
		return gardener
	},

	oldSelections: function() {
		const data = _.cloneDeep(_.get(this.options.filter, 'rollupIsAnyFilters'))
		if (this.options.filter?.operator === 'is-not-any' && !_.isEmpty(data)) {
			_.each(_.keys(data), id => {
				data[id] = data[id] === 'item-rollups-and-descendants'
			})
		}
		return data
	},

	newSelections() {
		let selections = {}
		if (this.rollupPermissions) {
			this.$('.table tbody tr[data-id]').each((i, el) => {
				var id = $(el).data('id')
				var permission = $(el).find('select').val()
				selections[id] = permission
			})
		} else {
			selections = _.mapValues(
				MultiTreeSelector.prototype.newSelections.apply(this, arguments),
				cascade => cascade ? 'item-rollups-and-descendants' : 'item-only')
		}
		return selections
	},

	render: function() {
		MultiTreeSelector.prototype.render.apply(this, arguments)
		this.$('.tree-selector-tree').addClass('dataset-tree-item-selector datasets-tree single-tree-selector')

		// #20557 hide the cascade help, which isn't really accurate in this case
		if (this.rollupPermissions &&
			this.options.filter.operator === 'is-any') {
			this.$('.cascade-cell').addClass('is-not-displayed')
		}

		this.options.wizard?.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		if (this.rollupPermissions) {
			this.$el.addClass(MultiTreeSelector.prototype.className)
			this.$('.tree-selector-table').addClass('is-single-column')
		}
	},

	context: function() {
		return {
			title: this.options.title ?? this.options.wizard.step2Title(),
			treeLabel: i18n.get('datasets.dataType.rollupTree.choose'),
			selectedLabel: i18n.get('datasets.dataType.rollupTree.selected'),
			noneSelectedKey: 'datasets.dataType.rollupTree.selected.none',
			submitLabel: i18n.get('common.done'),
			cascadeHelpKey: 'datasets.dataType.rollupTree.cascade'
		}
	},

	_buildRow: function() {
		let row = MultiTreeSelector.prototype._buildRow.apply(this, arguments)
		var treeId = row.data('id')
		if (this.keyDisplay().isDisplayed()) {
			var label = this.keyDisplay().labelAndKeys(treeId)
			row.find('.table-cell-text').text(label)
		}
		if (this.rollupPermissions) {
			// replace checkbox with dropdown
			row.addClass('has-select')
				.find('.label-cell')
				.append('<label class="full-width"><select></label>')
			let selectedValue = _.get(this.options.filter.rollupIsAnyFilters, treeId)
			let selectEl = row.find('select')
			rollupFilterDropdown(selectEl, selectedValue, {
				isPermissionFilter: this.options.showPermissionFilters
			})
			this.markedFields.push(new MarkedField({
				el: selectEl,
				validator: requiredValidator
			}).render())
		}
		return row
	},

	/**
	 * Returns a KeyDisplay suitable for this tree.  Should only be called
	 * after the tree has fully loaded.
	 */
	keyDisplay: function() {
		if (!this._keyDisplay) {
			var field = this.model.combinedFieldsById[this.options.filter.fieldId]
			var treeItemsById = _.keyBy(this.gardener.tree.nodes, 'id')
			this._keyDisplay = new KeyDisplay({
				model: this.model,
				field: field,
				filter: this.options.filter,
				treeItemsById: treeItemsById
			})
		}

		return this._keyDisplay
	},

	saveState: function() {
		this.options.filter.rollupIsAnyFilters = this.newSelections()
		// #35465 add flag making it clear we're working with rollup
		// permissions. The flag isn't saved to the DB
		this.options.filter.isPermissionFilter = this.options.showPermissionFilters
	},

	test: function() {
		if (this.options.allowIncomplete) {
			return
		}

		if (_.isEmpty(this.newSelections())) {
			return i18n.get('datasets.dataType.rollupTree.required')
		}
	},

	submit: function() {
		this.saveState()
		// important: this needs to go before calling superclass so that
		// the fact that the filter is valid is recorded properly
		this.options.filter.valid = true
		MultiTreeSelector.prototype.submit.apply(this, arguments)
	},

	remove: function() {
		MultiTreeSelector.prototype.remove.apply(this, arguments)
		_.invokeMap(this.markedFields, 'remove')
	}

})

export default DatasetsRollupFilterStep2

DatasetsRollupFilterStep2.__filename__ = 'datasets/filters/datasets-rollup-filter-step2.js'
